import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation } from 'swiper'
import styled from 'styled-components'
import 'swiper/swiper-bundle.min.css'

import { BrandCarouselItem } from './BrandCarouselItem'
import { CarouselButton } from 'components/CarouselButton/CarouselButton'
import { IImage } from '../../../graphql/types'

SwiperCore.use([Navigation])
const Wrapper = styled.div`
  position: relative;
`

const breakpoints = {
  0: {
    slidesPerView: 2,
    spaceBetween: 20,
  },
  768: {
    slidesPerView: 3,
    spaceBetween: 24,
  },
  1300: {
    slidesPerView: 4,
  },
  1920: {
    slidesPerView: 5,
  },
}
export type BrandCarouselProps = {
  icons: { alternativeText: string; image: string }[]
}
export const BrandCarousel = ({ icons }: BrandCarouselProps) => {
  return (
    <Wrapper>
      <Swiper
        breakpoints={breakpoints}
        spaceBetween={24}
        slidesPerView={4}
        scrollbar={false}
        navigation={{
          nextEl: '.next',
          prevEl: '.prev',
        }}
      >
        {icons.map((icon, i) => (
          <SwiperSlide key={i}>
            <BrandCarouselItem alt={icon.alternativeText} image={icon.image} />
          </SwiperSlide>
        ))}
      </Swiper>
      <CarouselButton className="prev" position="prev" />
      <CarouselButton className="next" position="next" />
    </Wrapper>
  )
}
